import Apiservice from '@/core/services/api.service';
import { API_URL } from '@/common/config.js'
const apiService = Apiservice;


export default class AcademicYearService {

      #api = null;

      constructor() {
            this.#api = `${API_URL}user/academic-year`;

      }
      all() {
            let url = `${this.#api}-all`;
            return apiService.get(url);
      }

      getIncompletedAcademicYears(){
            let url = `${this.#api}/incomplete/get`;
            return apiService.get(url);
      }

      paginate(type = null) {
            let url = `${this.#api}`;
            if (type)
                  url = url + '?type=' + type;
            return apiService.get(url);
      }

      update(id, data) {
            let url = `${this.#api}/${id}`
            return apiService.put(url, data);

      }

      store(data) {
            let url = `${this.#api}`
            return apiService.post(url, data);

      }

      show(id) {
            let url = `${this.#api}/${id}`
            return apiService.get(url);
      }
      delete(id) {
            let url = `${this.#api}/${id}`
            return apiService.delete(url);
      }
      markAsComplete(id,data){
            let url = `${this.#api}/${id}/mark-as-complete`;
            return apiService.post(url, data);
      }

      setAsCurrentYear(id){
            let url = `${this.#api}/${id}/set-as-current`;
            return apiService.post(url);
      }

      enableAutoIncrementFee(id){
            let url = `${this.#api}/${id}/enable-auto-increment-fee`;
            return apiService.post(url);
      }

      disableAutoIncrementFee(id){
            let url = `${this.#api}/${id}/disable-auto-increment-fee`;
            return apiService.post(url);
      }
}
